import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import Layout from "./components/Layout";
import Main from "./components/Main";
import DBFooter from "./components/dashboard/DBFooter";
import DBHeader from "./components/dashboard/DBHeader";

const DashboardLayout: React.FC = () => {
	const themeName = "light";

	const [isSidebarOpened, setIsSidebarOpened] = useState<boolean>(!(window.innerWidth < 991.98));
	const [isSmallView, setIsSmallView] = useState<boolean>(window.innerWidth < 991.98);

	const getWindowSize = () => {
		const isMobile = window.innerWidth < 991.98;
		setIsSidebarOpened(() => !isMobile);
		setIsSmallView(() => isMobile);
	};

	useEffect(() => {
		window.addEventListener("resize", getWindowSize);

		return () => {
			window.removeEventListener("resize", getWindowSize);
		};
	}, []);

	return (
		<>
			<Layout>
				<DBHeader
					theme={themeName}
					isSmallView={isSmallView}
					sidebarOpened={isSidebarOpened}
					toggleSidebar={() => setIsSidebarOpened((prev) => !prev)}
				/>

				<Main>
					<Outlet />
				</Main>

				<DBFooter />
			</Layout>
		</>
	);
};

export default DashboardLayout;
